module.exports = {
  currentTime: 0,
};
